import React from "react";
import "../mspMembersAccess.scss";
import ImageWithInitials from "../../../../Utils/ImageWithInitials";
import { Dropdown, OverlayTrigger, Tooltip } from "react-bootstrap";

const MemberItem = ({
  tooltipText = '',
  status,
  showInitials = false,
  initials = '',
  image = '',
  userName = '',
  fullName = '',
  roleName = '',
  roles = [],
  selectedRoleId,
  isAdmin = false,
  isDropdownDisabled = false,
  onItemClick = () => { },
  onCreateRoleClick = () => { },
  onRoleItemClick = (item) => { },
  onDeleteClick = (item) => { },
}) => {
  return (
    <div className="table-data border-item">
      <tr className="grid-container">
        <td className={`d-flex align-items-center ${(status === "active" || status === "inactive") && "pointer"}`}
          onClick={onItemClick}
        >
          {showInitials ? (
            <ImageWithInitials
              initials={initials}
              width={30}
              background={"purple"}
              backgroundColor={status === "pending" ? "#D4D6DD" : undefined}
              textColor={status === "pending" ? "#616778" : undefined}
              border={status === "pending" ? "dashed 1px #9499AA" : undefined}
            />
          ) : (<img alt="" src={image} className="" style={{ width: "30px", borderRadius: "50%", objectFit: "contain" }} />)
          }

          <div className="ml-2">
            {status === "pending" ? (
              <>
                <p className="user-name m-0" style={{ color: "#616778" }}>{userName}</p>
                <div className="d-flex align-content-center">
                  <img src="/images/msp/dummy-clock.svg" alt="" className="inviteClock mr-2" />
                  <p className="user-email m-0" style={{ color: "#9499AA" }}>Invite sent</p>
                </div>
              </>
            ) : (
              <>
                <p className="user-name m-0">{fullName}</p>
                <p className="user-email m-0">{userName}</p>
              </>
            )}
          </div>
        </td>
        <td className="d-flex align-items-center member-drop">
          {
            <Dropdown className="hg-white-dropdown user-detail-dropdown" disabled={isDropdownDisabled || isAdmin}>
              <OverlayTrigger
                placement="bottom"
                trigger={(isDropdownDisabled || isAdmin) ? ["hover", "focus"] : []}
                delay={{ show: 200, hide: 250 }}
                overlay={
                  <Tooltip id={`tooltip-1365`}>{tooltipText}</Tooltip>
                }
              >
                <Dropdown.Toggle className={`custom-dropdown-toggle f-gray-imp`} disabled={isDropdownDisabled || isAdmin}>
                  {roleName ? (roleName?.length < 30 ? roleName : `${roleName?.slice(0, 30)}...`) : "Select"}
                </Dropdown.Toggle>
              </OverlayTrigger>
              <Dropdown.Menu renderOnMount popperConfig={{ strategy: "fixed" }}>
                <div className="p-2 pl-3 my-1 pointer f-darkgrey"
                  style={{ display: "grid", "grid-template-columns": "10% 90%" }}
                  onClick={(e) => {
                    onCreateRoleClick();
                    e.target.closest(".hg-white-dropdown").click();
                  }}
                >
                  <img alt="" src="/images/settings-v2/lightgrey-plus-icon.svg" className="mr-2" />
                  <div>Create Access Role</div>
                </div>
                <div style={{ maxHeight: "200px", overflowY: "auto" }}>
                  {roles.map((el) => {
                    return (
                      <div className="p-2 pl-3 my-1 pointer f-grey"
                        key={el.RoleName + userName}
                        style={{ display: "grid", "grid-template-columns": "10% 90%" }}
                        onClick={(e) => {
                          onRoleItemClick(el);
                          e.target.closest(".hg-white-dropdown").click();
                        }}
                      >
                        <div>
                          {selectedRoleId?.split(",")?.map(Number)?.map((membRoleId) =>
                            membRoleId === el?.objId_AccessRole ? <img alt="" src="/images/settings-v2/check-icon.svg" className="mr-2" /> : <></>
                          )}
                        </div>

                        <div>
                          {el.RoleName}
                          <div className="smallGreyText text-ellipsis f-darkgrey">{el.RoleDescription}</div>
                        </div>
                      </div>
                    );
                  })}
                </div>

                <hr style={{ width: "80%", margin: "auto", marginTop: "12px", marginBottom: "8px", height: "2px" }} />
                <div className="ml-4 p-2 pl-3 my-1 pointer f-danger"
                  onClick={(e) => {
                    onDeleteClick();
                    e.target.closest(".hg-white-dropdown").click();
                  }}
                >
                  Delete User
                </div>
              </Dropdown.Menu>
            </Dropdown>
          }
        </td>
      </tr>
    </div>
  );
};

export default MemberItem;
